import { forwardRef, type Ref, type SVGProps } from "react";
const IconCreditScoreOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.341 26.775c-.441.228-.986.1-1.25-.322a13.93 13.93 0 0 1-2.124-7.417c0-7.732 6.268-14 14-14s14 6.268 14 14a13.93 13.93 0 0 1-2.115 7.403c-.264.423-.812.552-1.254.321l-3.507-1.827c-.577-.3-.715-1.064-.366-1.614a8 8 0 1 0-13.504.02c.352.55.214 1.32-.367 1.62zm1.739-3.15-1.778.918a11.94 11.94 0 0 1-1.335-5.507c0-1.135.158-2.233.452-3.274l1.857.797a10 10 0 0 0-.309 2.477c0 1.651.402 3.213 1.113 4.588M15 7.074c-4.37.348-8.08 3.038-9.876 6.814l1.84.789A10 10 0 0 1 15 9.083zm10.694 9.63c.178.748.273 1.528.273 2.331a10 10 0 0 1-1.101 4.566l1.775.925a11.94 11.94 0 0 0 1.326-5.49c0-1.084-.143-2.133-.412-3.13zm-.66-1.894 1.839-.788C25.11 10.195 21.393 7.455 17 7.08v2.01a10.01 10.01 0 0 1 8.033 5.721"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M14.136 20.276a1.99 1.99 0 0 1 .729-1.72l5.092-4.122c.886-.718 2.09.37 1.466 1.325l-3.533 5.397c-.344.525-.91.864-1.536.92l-.063.005a1.987 1.987 0 0 1-2.155-1.805"
    />
  </svg>
);
const ForwardRef = forwardRef(IconCreditScoreOutlineSVG);
ForwardRef.displayName = "IconCreditScoreOutline";
export { ForwardRef as IconCreditScoreOutline };
